
import React, { useEffect, useState, useContext } from "react";
import { getMachines } from "../api";
import { useNavigate } from "react-router-dom";
import { LanguageContext } from "../context/LanguageContext"

const MachinesList1 = ({ id_c, onSelect }) => {
    const { t } = useContext(LanguageContext); // 👈 Usa el hook para traer traducciones
    const [data, setData] = useState(null);
    const navigate = useNavigate();

    useEffect(() => {
        const fetchData = async () => {
            const result = await getMachines(id_c);
            setData(result);
        };
        fetchData();
    }, [id_c]);

    if (!data) return <p>{t('MList1')}</p>;

    return (

        <select
      className="input1"
      onChange={(e) => onSelect(e.target.value)}
      required
    >
      <option value="">-- {t("MList2") || "Selecciona una máquina"} --</option>
      {data.machines.map((machine) => (
        <option key={machine.cod_maq} value={machine.cod_maq}>
          {machine.cod_maq}
        </option>
      ))}
    </select>
  );
};

export default MachinesList1;